'use strict';
const lazyLoad = (() => {
    let images = [];
    let iObserver;
    const selector = '[data-lazy-src]';
    const config = {
        rootMargin: '200px 0px'
    };

    const init = () => {
        initEvents();

        document.querySelectorAll(selector).forEach(getElement);

        new (window.MutationObserver || window.WebKitMutationObserver)(
            (mutationList) => {
                mutationList.forEach(
                    ( mutation ) => mutation.addedNodes.forEach( (elem) => {
                        if (!elem || !elem.matches ) return;

                        if (elem.matches(selector))
                            return getElement(elem);

                        elem.querySelectorAll(selector).forEach(getElement);
                    } )
                )
            }
        ).observe(
            document.body,
            {
                childList : true,
                subtree: true
            }
        );
    };

    const initEvents = () => {
        if ('IntersectionObserver' in window) {
            iObserver = new IntersectionObserver(handleIntersection, config);
        } else {
            window.addEventListener('scroll', ()=> {
                images.forEach(image => checkSingle(image));
            });
        }
    };

    const getElement = (element) => {
        images.push(element);

        if ('IntersectionObserver' in window) {
            iObserver.observe(element);
        } else {
            checkSingle(element);
        }
    };

    const loadImage = (image) => {
        const src = image.dataset.lazySrc;
        if (!src) return;
        const attrName = image.tagName === "SOURCE" ? 'srcset' : 'src';
        image.setAttribute( attrName, src );
        image.removeAttribute('data-lazy-src');
    };

    const handleIntersection = (entries) => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
                iObserver.unobserve(entry.target);
                loadImage(entry.target);
            }
        });
    };

    const _checkPosition = (image) => {
        return image.getBoundingClientRect().top * 0.3 <= window.innerHeight;
    };

    const checkSingle = (image) => {
        if (_checkPosition(image)) {
            loadImage(image);
        }
    };

    return {
        init: init
    };
})();

export default lazyLoad
